const colors = {
  mainBlue: '#0058F3',
  secondBlue: '#2656A7',
  thirdBlue: '#2A334C',
  fourthBlue: '#3AACF6',
  mainGray: '#f7f9fc',
  secondGray: '#C1CFE6',
  thirdGray: '#4D6376',
  white: '#FFFFFF',
  red: '#f85656',
}

export const size = {
  tablet: '1000px',
}

export const device = {
  tabletMax: `(max-width: ${size.tablet})`,
}

export const fontSizes = {
  small: '12px',
  medium: '20px',
  large: '16px',
}

export { colors }
